import { useState } from 'react';

import FFHModal from '@components/modal';
import { H2 } from '@components/atoms/typography';
import { TeamImportPanel } from '@components/my-team/TeamImportPanel';

type TeamImportModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onImport: (fplTeamId: number) => Promise<void> | void;
  isImporting: boolean;
  title: string;
  description: string;
};

export const TeamImportModal = ({
  isOpen,
  onClose,
  onImport,
  isImporting,
  title,
  description
}: TeamImportModalProps) => {
  const [isPanelBusy, setIsPanelBusy] = useState(false);

  const handleClose = () => {
    if (isImporting || isPanelBusy) return;
    onClose();
  };

  return (
    <FFHModal open={isOpen} handleClose={handleClose} title={title}>
      <div
        className="flex flex-col gap-4 p-6 max-w-[500px]"
        data-cy="team-import-modal"
      >
        <H2>{title}</H2>
        <TeamImportPanel
          onImport={onImport}
          isImporting={isImporting}
          description={description}
          onImported={onClose}
          onBusyChange={setIsPanelBusy}
        />
      </div>
    </FFHModal>
  );
};
